import {IEntityDefinition} from "./i-entity-definition";

// Services that define shape of a form for modifying entity via entity definition.
export interface IFormEntityService<T = any> {
  getEntityDefinition(...args: any): IEntityDefinition[];
  isMultilanguage?: boolean;
}
